



















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ImportacaoPagamentosStore from '@/components/RemuneracaoMedica/financeiro/Store/ImportacaoPagamentosStore'
import EventBus from '@/plugins/EventBus'
import { TIPO_IMPORTACAO_OPTIONS, tipoImportacaoTemplate } from '@/utils/importacaoPagamentos'

@Component
export default class NovaImportacaoModal extends Vue {
  inputFiles: any[] = []
  arquivo: any = null
  tipoImportacao: string = ''
  loading: boolean = false

  get store() {
    return getModule(ImportacaoPagamentosStore, this.$store)
  }

  get tipoOptions() {
    return TIPO_IMPORTACAO_OPTIONS
  }

  get templateUrl() {
    const template = tipoImportacaoTemplate(this.tipoImportacao)
    if (!template) return ''
    const base = process.env.BASE_URL || '/'
    return `${base}templates/${template}`
  }

  get show() {
    return this.store.modalNovaImportacao
  }

  set show(value: boolean) {
    this.store.setModalNovaImportacao(value)
  }

  get podeEnviar() {
    return !!this.arquivo && !!this.tipoImportacao
  }

  isXlsx(file: any): boolean {
    if (!file) return false
    const nome = (file.name || '').toLowerCase()
    return nome.endsWith('.xlsx')
  }

  onInputFile(newFile: any) {
    if (newFile && newFile.file) {
      this.setArquivo(newFile.file)
    }
  }

  setArquivo(file: any) {
    if (!this.isXlsx(file)) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Formato inválido. Selecione um arquivo .xlsx.',
        icon: 'warning',
        color: '#C62828',
      })
      this.removeFile()
      return
    }
    this.arquivo = file
  }

  dropHandler(e: any) {
    e.preventDefault()
    const { files } = e.dataTransfer
    if (files && files.length) {
      this.setArquivo(files[0])
    }
    this.changeStyleDiv('leave')
  }

  changeStyleDiv(type: 'enter' | 'leave') {
    const divUpload = document.getElementById('div-upload-importacao')
    if (divUpload) {
      divUpload.className = type === 'enter'
        ? 'div-upload div-upload-background-drag-enter'
        : 'div-upload div-upload-background-default'
    }
  }

  removeFile() {
    this.arquivo = null
    this.inputFiles = []
  }

  async enviar() {
    if (!this.podeEnviar) return
    this.loading = true

    const response = await this.store.uploadArquivo({
      arquivo: this.arquivo,
      tipoImportacao: this.tipoImportacao,
    })

    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Arquivo enviado com sucesso. O processamento será feito em segundo plano.',
        icon: 'done',
        color: '#2E7D32',
      })
      this.$emit('uploaded')
      this.close()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Não foi possível enviar o arquivo.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loading = false
  }

  close() {
    this.show = false
  }

  @Watch('show')
  onShowChange(value: boolean) {
    if (!value) {
      this.removeFile()
      this.tipoImportacao = ''
    }
  }
}
